import { aiCharacterChatDifficultyTypeSchema, curriculumTypeSchema, langTypeSchema } from '@server/presentation'
import { z } from 'zod'

/** 레슨 탭에서 조회 가능한 수업 언어. KR은 JP 시장 전용 코스에서 사용한다. */
export const lectureCourseLangTypeSchema = z.enum(['EN', 'JP', 'KR'])

const bookTitleSchema = z
  .union([z.string(), z.record(z.unknown())])
  .nullable()
  .optional()

export const lessonGroupSchema = z.object({
  id: z.string(),
  level: z.string().nullable(),
  name: z.string(),
  kr_name: z.string().optional(),
  book_title: bookTitleSchema,
  book_name: z.string().nullable().optional(),
  class_level_name: z.string().nullable().optional(),
  description: z.string().nullable(),
  thumbnail: z.string().nullable(),
  minute: z.string(),
  class_level: z.string(),
  lesson_count: z.string(),
  class_course_id: z.string().nullable(),
  curriculum_type: curriculumTypeSchema.nullable(),
})

// UI 구성 정보를 위한 스키마
export const uiConfigSchema = z.object({
  visibility: z.boolean(),
  iconType: z.enum(['business']).optional(),
  showFilters: z.boolean(),
  layout: z.enum(['carousel']),
  theme: z
    .object({
      background: z.string().optional(),
      textColor: z.string().optional(),
    })
    .optional(),
})

export const subscribeSchema = z.object({
  name: z.string(),
  levels: z.array(z.string()).nullable(),
  lesson_groups: z.array(lessonGroupSchema),
  is_purchased: z.boolean(),
  curriculum_type: curriculumTypeSchema,
  is_business: z.boolean().optional(),
  uiConfig: uiConfigSchema.optional(),
  lesson_time: z.string(),
})

export const getLectureCourseListRequestSchema = z.object({
  langType: lectureCourseLangTypeSchema,
  acceptLanguage: z.string().optional().default('ko'),
})

export const lectureCourseResponseSchema = z.object({
  lang_type: lectureCourseLangTypeSchema,
  levels: z.array(z.string()).nullish(),
  subscribes: z.array(subscribeSchema),
})

export const aiLectureCourseRequestSchema = z.object({
  langType: langTypeSchema,
  difficulty: aiCharacterChatDifficultyTypeSchema,
  acceptLanguage: z.string().optional().default('ko'),
})

export const aiLectureCourseResponseSchema = z.object({
  difficulty: z.string(),
  langType: langTypeSchema,
  isPurchased: z.boolean(),
  lessonGroups: z.array(
    z.object({
      name: z.string(),
      classLevel: z.number(),
      curriculumType: curriculumTypeSchema,
      subscribes: z.array(
        z.object({
          classCourseId: z.number(),
          name: z.string(),
          description: z.string(),
          thumbnail: z.string(),
          lessonTime: z.number(),
          classWeek: z.number(),
        }),
      ),
    }),
  ),
})

export type LessonGroup = z.infer<typeof lessonGroupSchema>
export type LessonListUIConfig = z.infer<typeof uiConfigSchema>
export type Subscribe = z.infer<typeof subscribeSchema>
export type LectureCourseLangType = z.infer<typeof lectureCourseLangTypeSchema>
export type LectureCourseResponse = z.infer<typeof lectureCourseResponseSchema>
export type AiLectureCourseResponse = z.infer<typeof aiLectureCourseResponseSchema>
